export const KEIRIN_TERMS_URL = `${
  import.meta.env.VITE_DMM_TERMS_URL
}/chariloto`;

export const TORETA_TERMS_URL = `${
  import.meta.env.VITE_DMM_TERMS_URL
}/toretaplus`;

export const TOKUSHOU_TERMS_URL = `${
  import.meta.env.VITE_DMM_TERMS_URL
}/keirin_tokushou`;
